import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { DocumentTextIcon, BookmarkIcon } from '@heroicons/react/24/outline';

export function TemplateManager() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { name: 'Contract Templates', path: '/templates/contracts', icon: DocumentTextIcon },
    { name: 'Scopes', path: '/templates/scopes', icon: BookmarkIcon },
  ];

  const currentTab = tabs.find(tab => location.pathname.startsWith(tab.path)) || tabs[0];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-6 sm:py-8">
        <div className="mb-6">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Template Management</h1>
          <p className="mt-2 text-gray-600">Manage contract templates and reusable scopes</p>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-sm">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px overflow-x-auto">
              {tabs.map((tab) => {
                const Icon = tab.icon;
                const isActive = location.pathname.startsWith(tab.path);
                return (
                  <button
                    key={tab.name}
                    onClick={() => navigate(tab.path)}
                    className={`flex items-center gap-2 px-4 sm:px-6 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap shrink-0 ${
                      isActive
                        ? 'border-primary-600 text-primary-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                    {tab.name}
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-4 sm:p-6">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

